import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';


export const getPagosCliente = async ( fechaStart, fechaEnd ) => {
     try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/pagos/cliente?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}&idCliente=${userInfo.usuario}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
 /* return [
    {
      fecha: "2025-06-01",
      nombrePlan: "Plan Básico",
      medioPago: "Tarjeta de Crédito",
      monto: 12990,
    },
    {
      fecha: "2025-06-28",
      nombrePlan: "Plan Premium",
      medioPago: "Transferencia",
      monto: 19990,
    },
  ];*/
};


export const getRegistroPagos = async (fechaStart,fechaEnd ,estado) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/pagos?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}&estado=${estado}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getRegistroPagosRut = async (rutCliPro,numeroPago) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/pagos/rut?empresa=${userInfo.empresa}&rutCliPro=${rutCliPro}&numeroPago=${numeroPago}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearRegistroPago = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/pagos', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateRegistroPago = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/pagos/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteRegistroPago = (Id) => Axios.delete(`/pagos/${Id}`);